import moment from 'moment';

import { DatePresetType } from './types';

export const RANGE_PRESETS: Array<DatePresetType> = [
  {
    id: 'lastWeek',
    label: 'Last 7 Days',
    generateRange: () => ({
      startDate: moment().startOf('day').subtract(7, 'days').toDate(),
      endDate: moment().endOf('day').toDate(),
    }),
  },
  {
    id: 'lastTwoWeeks',
    label: 'Last 14 Days',
    generateRange: () => ({
      startDate: moment().startOf('day').subtract(14, 'days').toDate(),
      endDate: moment().endOf('day').toDate(),
    }),
  },
  {
    id: 'lastMonth',
    label: 'Last 30 Days',
    generateRange: () => ({
      startDate: moment().startOf('day').subtract(30, 'days').toDate(),
      endDate: moment().endOf('day').toDate(),
    }),
  },
  {
    id: 'lastThreeMonths',
    label: 'Last 3 Months',
    generateRange: () => ({
      startDate: moment().startOf('day').subtract(3, 'months').toDate(),
      endDate: moment().endOf('day').toDate(),
    }),
  },
  {
    id: 'lastYear',
    label: 'Last 12 Months',
    generateRange: () => ({
      startDate: moment().startOf('day').subtract(12, 'months').toDate(),
      endDate: moment().endOf('day').toDate(),
    }),
  },
  {
    id: 'monthToDate',
    label: 'Month to Date',
    generateRange: () => ({
      startDate: moment().startOf('month').toDate(),
      endDate: moment().endOf('day').toDate(),
    }),
  },
  {
    id: 'quarterToDate',
    label: 'Quarter to Date',
    generateRange: () => ({
      startDate: moment().startOf('quarter').toDate(),
      endDate: moment().endOf('day').toDate(),
    }),
  },
  {
    id: 'all',
    label: 'All Time',
    generateRange: () => ({
      startDate: null,
      endDate: null,
    }),
  },
];
